import { AUTH_GRID_IMAGES, buildMarqueeColumns } from '../lib/authGridImages';

const AUTH_COLUMN_COUNT = 4;
const DESKTOP_MARQUEE_MEDIA = '(min-width: 768px)';

function isDesktopMarqueeViewport() {
  return window.matchMedia(DESKTOP_MARQUEE_MEDIA).matches;
}

function renderMarquee(root) {
  const columns = buildMarqueeColumns(AUTH_GRID_IMAGES, { columnCount: AUTH_COLUMN_COUNT });

  root.replaceChildren(
    ...columns.map((column) => {
      const col = document.createElement('div');
      col.className = 'auth-marquee-col';
      col.dataset.dir = column.direction;
      col.style.marginTop = `${column.offsetPx}px`;
      col.style.setProperty('--marquee-duration', `${column.durationSeconds}s`);

      const track = document.createElement('div');
      track.className = 'auth-marquee-track';

      column.tiles.forEach((tile) => {
        const img = document.createElement('img');
        img.src = tile.src;
        img.alt = '';
        img.loading = 'eager';
        img.decoding = 'async';
        img.className = 'auth-marquee-img';
        track.appendChild(img);
      });

      col.appendChild(track);
      return col;
    })
  );
}

function mountAuthMarquee() {
  const root = document.querySelector('.auth-marquee');
  if (root === null) {
    return;
  }

  if (!isDesktopMarqueeViewport()) {
    root.replaceChildren();
    return;
  }

  if (root.childElementCount > 0) {
    return;
  }

  renderMarquee(root);
}

function scheduleMarqueeMount() {
  window.requestAnimationFrame(() => {
    mountAuthMarquee();
  });
}

function registerMarqueeMountListeners() {
  if (window.__authMarqueeListenersRegistered === true) {
    scheduleMarqueeMount();
    return;
  }

  window.__authMarqueeListenersRegistered = true;

  const mountEvents = [ 'turbo:load', 'turbo:render', 'turbo:morph', 'pageshow' ];
  mountEvents.forEach((eventName) => {
    document.addEventListener(eventName, scheduleMarqueeMount);
  });

  window.matchMedia(DESKTOP_MARQUEE_MEDIA).addEventListener('change', scheduleMarqueeMount);

  if (window.MutationObserver !== undefined) {
    const observer = new window.MutationObserver(() => {
      mountAuthMarquee();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  scheduleMarqueeMount();
}

registerMarqueeMountListeners();
